import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import withImmutablePropsToJS from "with-immutable-props-to-js";

import BidButton from "storefront/features/productGrid/components/BidButton";
import UnregisteredUserModal from "storefront/features/shared/components/unregisteredUserModal/components/UnregisteredUserModal";
import { getAuctionData } from "storefront/features/shared/components/Header/selectors";
import { isExpired } from "storefront/features/shared/utils";
import { suggestionToProduct } from "../utils";
import { SuggestionBidButtonWrap } from "./BiddingSuggestionsModal.styled";

class SuggestionBidButton extends PureComponent {
  state = { modalOpen: false };

  onModalOpen = () => {
    this.setState({ modalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpen: false });
  };

  buildProduct = () => suggestionToProduct(this.props.suggestion);

  render() {
    const { userAuctionData, suggestion } = this.props;
    const product = this.buildProduct();
    const closed = isExpired(suggestion.end_at);

    return (
      <SuggestionBidButtonWrap>
        <BidButton
          vendorPresent={userAuctionData?.vendor}
          closed={closed}
          product={product}
          onModalOpen={this.onModalOpen}
          showBidValue={true}
          width="100%"
        />
        {this.state.modalOpen && (
          <UnregisteredUserModal
            product={product}
            onClose={this.handleModalClose}
          />
        )}
      </SuggestionBidButtonWrap>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userAuctionData: getAuctionData,
});

export default connect(mapStateToProps)(withImmutablePropsToJS(SuggestionBidButton));
